import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const ComparisonContext = createContext(null)

const MAX_COMPARISON = 3

export const ComparisonProvider = ({ children }) => {
  const [comparisonIds, setComparisonIds] = useState([])

  const addToComparison = useCallback((id) => {
    setComparisonIds((prev) => {
      if (prev.includes(id)) return prev
      if (prev.length >= MAX_COMPARISON) return prev
      return [...prev, id]
    })
  }, [])

  const removeFromComparison = useCallback((id) => {
    setComparisonIds((prev) => prev.filter((cId) => cId !== id))
  }, [])

  const clearComparison = useCallback(() => {
    setComparisonIds([])
  }, [])

  const isInComparison = useCallback((id) => comparisonIds.includes(id), [comparisonIds])

  const value = useMemo(
    () => ({
      comparisonIds,
      addToComparison,
      removeFromComparison,
      clearComparison,
      isInComparison,
      isFull: comparisonIds.length >= MAX_COMPARISON,
    }),
    [comparisonIds, addToComparison, removeFromComparison, clearComparison, isInComparison],
  )

  return <ComparisonContext.Provider value={value}>{children}</ComparisonContext.Provider>
}

export const useComparison = () => {
  const ctx = useContext(ComparisonContext)
  if (!ctx) throw new Error('useComparison must be used within a ComparisonProvider')
  return ctx
}
